export interface IReferralLeaderboardEntry {
  rank: number;
  count: number;
  user: { id: string; username: string; avatarUrl: string | null };
}

export interface IReferralStanding {
  rank: number | null;
  count: number;
}

const plural = (count: number, word: string) =>
  `${count} ${word}${count === 1 ? "" : "s"}`;

export const referralsLabel = (count: number) => plural(count, "referral");

export const resetLabel = (periodEnd: string, now = Date.now()) => {
  const days = Math.ceil((Date.parse(periodEnd) - now) / 86_400_000);
  if (!(days > 0)) return "Resets today";
  if (days === 1) return "Resets tomorrow";
  return `Resets in ${days} days`;
};
